<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getRepackings"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-repacking-no" label-cols-sm="4" label-cols-lg="3" label="Repacking No" label-for="filter-repacking-no" size="sm" :model.sync="filter.repackingNo" />
					<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Delivery Instruction" id="filter-" size="sm" :model.sync="filter.deliveryInstructionId" @input="getDeliveryInstructions" @focus="getDeliveryInstructions" />
					<app-input-datepicker-range  id="fieldset-repack-date" label-cols-sm="4" label-cols-lg="3" label="Repack Date" size="sm" :modelFrom.sync="filter.repackDateFrom" :modelTo.sync="filter.repackDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-datepicker-range  id="fieldset-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Delivery Date" size="sm" :modelFrom.sync="filter.deliveryDateFrom" :modelTo.sync="filter.deliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-combobox-autocomplete :options="repackStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Repack Status" id="filter-" size="sm" :model.sync="filter.repackStatusId" @input="getRepackStatuss" @focus="getRepackStatuss" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Repack By" id="filter-" size="sm" :model.sync="filter.repackById" @input="getUserInfos" @focus="getUserInfos" />
					<app-input-datetimepicker-range id="fieldset-start-date" label-cols-sm="4" label-cols-lg="3" label="Start Date" size="sm" :modelFrom.sync="filter.startDateFrom" :modelTo.sync="filter.startDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-datetimepicker-range id="fieldset-finish-date" label-cols-sm="4" label-cols-lg="3" label="Finish Date" size="sm" :modelFrom.sync="filter.finishDateFrom" :modelTo.sync="filter.finishDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-textbox id="fieldset-po-no-customer" label-cols-sm="4" label-cols-lg="3" label="PO No Customer" label-for="filter-po-no-customer" size="sm" :model.sync="filter.poNoCustomer" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getRepackings"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Repacking</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm" v-if="false">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/repacking/Repacking.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton && false"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-repacking" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="repackings" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="repackings.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>

					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Repacking No" class="table-filter">
							<b-form-input id="input-repacking-no-table" @input="getRepackingsWithoutLoading" v-model="filter.repackingNo" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Repack Status" class="table-filter">
							<v-select append-to-body label="name" :options="repackStatuss" :value="filter.repackStatusId" :reduce="item => item.id" v-model="filter.repackStatusId" :filterable="true" @input="getRepackingsWithoutLoading" @search="getRepackStatuss"></v-select>
						</b-th>
						<b-th stacked-heading="Repack Date" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder="" id="input-repack-date-from-table" reset-button @input="getRepackingsWithoutLoading" v-model="filter.repackDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder="" id="input-repack-date-to-table" reset-button @input="getRepackingsWithoutLoading" v-model="filter.repackDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
						</b-th>
						<b-th stacked-heading="Delivery Date" class="table-filter">
							<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-from-table" reset-button @input="getRepackingsWithoutLoading" v-model="filter.deliveryDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
							<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-to-table" reset-button @input="getRepackingsWithoutLoading" v-model="filter.deliveryDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
						</b-th>
						<b-th stacked-heading="Delivery Instruction" class="table-filter">
							<v-select append-to-body label="diNumber" :options="deliveryInstructions" :value="filter.deliveryInstructionId" :reduce="item => item.id" v-model="filter.deliveryInstructionId" :filterable="true" @input="getRepackingsWithoutLoading" @search="getDeliveryInstructions"></v-select>
						</b-th>
						<b-th stacked-heading="Repack By" class="table-filter">
							<v-select append-to-body label="firstName" :options="userInfos" :value="filter.repackById" :reduce="item => item.id" v-model="filter.repackById" :filterable="true" @input="getRepackingsWithoutLoading" @search="getUserInfos"></v-select>
						</b-th>
						<b-th stacked-heading="Start Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-start-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Date" size="sm" :modelFrom.sync="filter.startDateFrom" :modelTo.sync="filter.startDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getRepackingsWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Finish Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-finish-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Finish Date" size="sm" :modelFrom.sync="filter.finishDateFrom" :modelTo.sync="filter.finishDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getRepackingsWithoutLoading" />
						</b-th>
						<b-th stacked-heading="PO No Customer" class="table-filter">
							<b-form-input id="input-po-no-customer-table" @input="getRepackingsWithoutLoading" v-model="filter.poNoCustomer" size="sm"></b-form-input>
						</b-th>
					</template>

					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(repackingno)="row">
						<a v-if="row.item.repackStatus.code == 'DONE'" @click="() => ( $router.push({ name: 'repackingdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.repackingNo != null && row.item.repackingNo != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.repackingNo.slice(0, 30) + (row.item.repackingNo.length > 30 ? "..." : "" ) : row.item.repackingNo : "" }}
						</a>
						<a v-if="row.item.repackStatus.code == 'OPEN' || row.item.repackStatus.code == 'IN_PROGRESS'" @click="() => ( $router.push({ name: 'repackingscaninprogress', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.repackingNo != null && row.item.repackingNo != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.repackingNo.slice(0, 30) + (row.item.repackingNo.length > 30 ? "..." : "" ) : row.item.repackingNo : "" }}
						</a>
					</template>

				<template v-slot:cell(repackStatus)="row">
					{{ row.item.repackStatus != null ? row.item.repackStatus.name : "" }}
				</template>
				<template v-slot:cell(deliveryInstruction)="row">
					{{ row.item.deliveryInstruction != null ? row.item.deliveryInstruction.diNumber : "" }}
				</template>
				<template v-slot:cell(repackDate)="row">
					{{ row.item.repackDate | moment("DD-MMM-YYYY") }}
				</template>
				<template v-slot:cell(deliveryDate)="row">
					{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
				</template>
				<template v-slot:cell(repackBy)="row">
					{{ row.item.repackBy != null ? row.item.repackBy.firstName : "" }}
				</template>
				<template v-slot:cell(startDate)="row">
					{{ row.item.startDate | moment("DD-MMM-YYYY HH:mm") }}
				</template>
				<template v-slot:cell(finishDate)="row">
					{{ row.item.finishDate | moment("DD-MMM-YYYY HH:mm") }}
				</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="false">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-datepicker  id="fieldset-repack-date" label-cols-lg="12"  label="Repack Date" size="sm" :model.sync="row.item.repackDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="row.item.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.repackStatusId" label="Repack Status" :selected="row.item.repackStatus != null ? row.item.repackStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="firstName" label-cols-sm="12" :model="row.item.repackByUserName" label="Repack By" :selected="row.item.repackBy != null ? row.item.repackBy.firstName : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-datetimepicker id="fieldset-start-date" label-cols-lg="12"  label="Start Date" size="sm" :model.sync="row.item.startDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-datetimepicker id="fieldset-finish-date" label-cols-lg="12"  label="Finish Date" size="sm" :model.sync="row.item.finishDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="PO No Customer" label-for="input-po-no-customer" size="sm" :model.sync="row.item.poNoCustomer"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(repackingsPaging != null ? repackingsPaging.dataCount : 0)"
									:per-page="(repackingsPaging != null ? repackingsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-repacking.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-repacking.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-repacking.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import Repacking from '@/models/Repacking/Repacking';
import RepackingList from '@/models/Repacking/RepackingList';
import RepackingFilter from '@/filters/Repacking/RepackingFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import RepackStatusFilter from '@/filters/RepackStatus/RepackStatusFilter';
import RepackStatus from '@/models/RepackStatus/RepackStatus';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import RepackingDetailFilter from '@/filters/Repacking/RepackingDetailFilter';
import RepackingDetail from '@/models/Repacking/RepackingDetail';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		Repacking, 
		RepackingList, 
		RepackingFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"repackingNo": {}, "class" : "th-repacking-no first-child", "label" : "Repacking No", key: 'repackingNo', sortable: true}, 
				{"repackStatus": {}, "class" : "th-repack-status", "label" : "Repack Status", key: 'repackStatus', sortable: true}, 
				{"repackDate": {}, "class" : "th-repack-date last-child", "label" : "Repack Date", key: 'repackDate', sortable: true}, 
				{"deliveryDate": {}, "class" : "th-delivery-date d-stack-none", "label" : "Delivery Date", key: 'deliveryDate', sortable: true}, 
				{"deliveryInstruction": {}, "class" : "th-delivery-instruction d-stack-none", "label" : "Delivery Instruction", key: 'deliveryInstruction', sortable: true}, 
				{"repackBy": {}, "class" : "th-repack-by d-stack-none", "label" : "Repack By", key: 'repackBy', sortable: true}, 
				{"startDate": {}, "class" : "th-start-date d-stack-none", "label" : "Start Date", key: 'startDate', sortable: true}, 
				{"finishDate": {}, "class" : "th-finish-date d-stack-none", "label" : "Finish Date", key: 'finishDate', sortable: true}, 
				{"poNoCustomer": {}, "class" : "th-po-no-customer d-stack-none", "label" : "PO No Customer", key: 'poNoCustomer', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			repackings: [],
			repackingsPaging: {},
			deliveryInstructions : [],
			repackStatuss : [],
			userInfos : [],
			repackingDetails : [],
			repackingControlCards : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
		}
	},	methods : {
		getRepackings : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			Repacking.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.repackings = result.data
					this.repackingsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getRepackingsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			Repacking.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.repackings = result.data
					this.repackingsPaging = result
				}
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		getRepackStatuss : async function(input) {
			let filter = new RepackStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			RepackStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.repackStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new RepackingFilter();
			this.getRepackings();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getRepackings();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				Repacking.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			Repacking.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			Repacking.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.$router.push({ name: 'repackingsearchscan' });

			// this.isCreateBusy = true;
			// Repacking.createData(this).then(result => {
			// 	if (result != null) {
			// 		if (result.id != null && result.id != "") {
			// 			let createRoute = 'repackingedit';
			// 			if(this.isScannerMode) {
			// 				createRoute = 'repackingscan';
			// 			}

			// 			this.$router.push({ name: createRoute, params : { id: result.id } });
			// 		}
			// 	}
			// 	this.isCreateBusy = false;
			// }).catch(error => {
			// 	this.isCreateBusy = false;
			// })
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			Repacking.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'repackingedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			Repacking.deleteData(this, id).then(result => {
				if (result)
				{
					this.getRepackings();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				Repacking.deleteMultipleData(this).then(result => {
					this.getRepackings();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableRepackingParent = document.getElementById('table-list-repacking').parentNode;
			tableRepackingParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableRepackingParent.scrollWidth - tableRepackingParent.offsetWidth) == Math.ceil(tableRepackingParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableRepackingParent = document.getElementById('table-list-repacking').parentNode;
			tableRepackingParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableRepackingParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new RepackingFilter();
		this.getDeliveryInstructions();
		this.getRepackStatuss();
		this.getUserInfos();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Repacking"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getRepackings();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getRepackings();
			}
		},
		sortDesc: {
			handler: function() {
				this.getRepackings();
			}
		},
		currentPage: {
			handler: function() {
				this.getRepackings();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getRepackings();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				Repacking.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "repackingindex") {
					this.getRepackingsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "repacking").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
